import { FirebaseAnalyticsTypes } from '@react-native-firebase/analytics';

const analytics = () => ({});

export {
  analytics,
  FirebaseAnalyticsTypes
}
